export class TbaRegistrationDTO{
    racfId: any;
    racfPassword: any;
    sessionId: any;
}    